var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-edit',{attrs:{"content-type":"reports","content-type-singular":"report","content-name":"Reports","content-name-singular":"Report"}})}
var staticRenderFns = []

export { render, staticRenderFns }